import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

function Navbar({ user }) { // أضفنا user هنا
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar-landing">
      <div className="container-custom navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img src="/img/logo.jpeg" alt="ديوان الأرض" style={{ height: '40px', marginRight: '10px', verticalAlign: 'middle', borderRadius: '4px' }} />
          <span className="logo-text">ديوان <span className="logo-accent">الأرض</span></span>
        </Link>

        {/* Desktop Links */}
        <div className="navbar-links desktop-only">
          <NavLink to="/" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>الرئيسية</NavLink>
          <NavLink to="/features" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>المميزات</NavLink>
          <NavLink to="/pricing" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>الأسعار</NavLink>
          <NavLink to="/about" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>عن المنصة</NavLink>
          <NavLink to="/contact" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>اتصل بنا</NavLink>
        </div>

        <div className="navbar-actions">
          {user ? (
            <div className="user-nav-info" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              <span className="welcome-text desktop-only" style={{ fontWeight: '500' }}>
                أهلاً، {user.profile?.full_name?.split(' ')[0] || 'مستخدم'}
              </span>
              <Link to="/dashboard" className="btn-primary-custom">لوحة التحكم</Link>
            </div>
          ) : (
            <>
              <Link to="/login" className="nav-link desktop-only" style={{ marginLeft: '30px' }}> دخول</Link>
              <Link to="/register" className="btn-primary-custom desktop-only">سجل الآن</Link>
            </>
          )}

          {/* Burger Button */}
          <button className="burger-btn mobile-only" onClick={toggleMenu} aria-label="Toggle menu">
            <span className="material-symbols-outlined">
              {isMenuOpen ? 'close' : 'menu'}
            </span>
          </button>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      <div className={`mobile-drawer ${isMenuOpen ? 'open' : ''}`}>
        <div className="drawer-links">
          {user && (
            <div className="drawer-user-info" style={{ padding: '15px', borderBottom: '1px solid #eee', marginBottom: '10px' }}>
              <span style={{ fontWeight: 'bold' }}>أهلاً، {user.profile?.full_name?.split(' ')[0]}</span>
            </div>
          )}
          <NavLink to="/" className={({ isActive }) => isActive ? "drawer-link active" : "drawer-link"} onClick={closeMenu}>الرئيسية</NavLink>
          <NavLink to="/features" className={({ isActive }) => isActive ? "drawer-link active" : "drawer-link"} onClick={closeMenu}>المميزات</NavLink>
          <NavLink to="/pricing" className={({ isActive }) => isActive ? "drawer-link active" : "drawer-link"} onClick={closeMenu}>الأسعار</NavLink>
          <NavLink to="/about" className={({ isActive }) => isActive ? "drawer-link active" : "drawer-link"} onClick={closeMenu}>عن المنصة</NavLink>
          <NavLink to="/contact" className={({ isActive }) => isActive ? "drawer-link active" : "drawer-link"} onClick={closeMenu}>اتصل بنا</NavLink>

          {user ? (
            <Link to="/dashboard" className="btn-primary-custom drawer-btn" onClick={closeMenu}>لوحة التحكم</Link>
          ) : (
            <>
              <Link to="/login" className="drawer-link" onClick={closeMenu}>تسجيل الدخول</Link>
              <Link to="/register" className="btn-primary-custom drawer-btn" onClick={closeMenu}>سجل الان</Link>
            </>
          )}
        </div>
      </div>

      {/* Backdrop */}
      {isMenuOpen && <div className="drawer-backdrop" onClick={closeMenu}></div>}
    </nav>
  );
}

export default Navbar;